import React, { useEffect, useRef, useState } from "react";
import werenium from "../assets/werenium.jpg";
import banner1 from "../assets/banner1.jpg";

export default function Werenium() {
  const containerRef = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Logic: Start animation when top of section reaches 60% of viewport
      // End animation when top of section reaches 0 (top of screen)
      const startTrigger = windowHeight * 0.6; 
      const endTrigger = 0;

      let rawProgress = (startTrigger - rect.top) / (startTrigger - endTrigger);
      rawProgress = Math.min(Math.max(rawProgress, 0), 1);

      const easedProgress = Math.pow(rawProgress, 1.2); 
      setProgress(easedProgress);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  return (
    <>
      <style>{`
        .w-shutter-container {
          position: relative;
          width: 100%;
          /* We need a defined height for sticky to work. 150vh gives scroll room. */
          height: auto; 
          background: #000;
        }

        .w-sticky-viewport {
          position: sticky;
          top: 0;
          height: 100vh;
          width: 100%;
          overflow: hidden;
        }

        .w-img-base {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
          transform: scale(${1.05 - progress * 0.05});
        }

        .w-shutter {
          position: absolute;
          left: 0;
          width: 100%;
          height: 50.2%; 
          z-index: 10;
          overflow: hidden;
          will-change: transform;
        }

        .w-shutter-top {
          top: 0;
          transform: translateY(-${progress * 100}%);
        }

        .w-shutter-bottom {
          bottom: 0;
          transform: translateY(${progress * 100}%);
        }

        .w-internal-img {
          position: absolute;
          width: 100%;
          height: 100vh;
          object-fit: cover;
          /* Ensures the subject stays centered on mobile */
          object-position: center; 
        }

        .w-shutter-bottom .w-internal-img { bottom: 0; }

        .w-shutter-dim {
          position: absolute;
          inset: 0;
          background: #000;
          opacity: ${progress * 0.4};
          z-index: 11;
        }

        /* ── Mobile Optimizations ── */
        @media (max-width: 768px) {
          .w-shutter-container {
            display:none;
          }
          
          .w-internal-img, .w-img-base {
            /* Force images to handle vertical aspect ratios better */
            width: 100%;
            height: 100%;
          }

          .w-shutter-top {
             /* Add a slight overlap to prevent a white gap line on some mobile browsers */
             height: 50.5%;
          }
        }
      `}</style>

      <section className="w-shutter-container" ref={containerRef}>
        <div className="w-sticky-viewport">
          <img src={werenium} className="w-img-base" alt="Revealed" />
          
          <div className="w-shutter w-shutter-top">
            <img src={banner1} className="w-internal-img" alt="Panel" />
            <div className="w-shutter-dim" />
          </div>

          <div className="w-shutter w-shutter-bottom">
            <img src={banner1} className="w-internal-img" alt="Panel" />
            <div className="w-shutter-dim" />
          </div>
        </div>
      </section>
    </>
  );
}